import React from "react";
import StatusPage from "./StatusPage";

/**
 * Cíl odkazu z ověřovacího e-mailu (continue URL /email-verified, nastavuje
 * AuthPage při sendEmailVerification). Titulek hlavičky dodává AppShell.
 * Profil člena vzniká až při prvním přihlášení s ověřeným e-mailem
 * (utils/completeRegistration) – text to říká, ať přihlášení nikdo nevynechá.
 */
const EmailVerified: React.FC = () => (
  <StatusPage
    icon="bi-envelope-check"
    tone="success"
    title="E-mail byl ověřen"
    text="Teď se přihlaste – při prvním přihlášení se registrace dokončí."
    action={{ label: "Přejít na přihlášení", to: "/login" }}
  />
);

export default EmailVerified;
